<template>
    <div>
        <action-bar>
        </action-bar>
        <main class="content">
            <div>
                <h1>Partner erstellen</h1>
                <div class="form-group">
                    <label for="input_name">Name</label>
                    <input type="text" class="form-control" v-model="name" id="input_name">
                </div>
                <div class="form-group">
                    <label for="input_name">URL</label>
                    <input type="text" class="form-control" v-model="url" id="input_url">
                </div>
                <button class="btn btn-primary" @click="save">Erstellen</button>
            </div>
        </main>
    </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      url: "http://"
    };
  },
  methods: {
    save() {
      let form = new FormData();
      form.append("create_partner[name]", this.name);
      form.append("create_partner[url]", this.url);
      form.set("create_partner[submit]", null);
      axios
        .post("/api/" + store.state.language + "/partner/create", form)
        .then(({ data }) => {
          this.$router.push({ name: "partner-list" });
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/partner/Create.vue